<template>
  <!-- <div class="container-fluid py-3"> -->
  <div class="container-fluid pt-3 pb-3 dispatch-detail-page">
    <!-- Header -->
    <div class="d-flex align-items-center gap-2 mb-3">
      <h5 class="mb-0">Dispatch Summary — Detail View</h5>
    </div>

    <!-- Filters -->
    <div class="card mb-3">
      <div class="card-body">
        <div class="row g-2">
          <div class="col-sm-6 col-md-3">
            <label class="form-label small text-muted mb-1">Distributor</label>
            <select
              v-model="selectedDistributor"
              class="form-select form-select-sm"
              @change="fetchData"
              :disabled="isDistributor"
            >
              <option v-if="!isDistributor" value="">All Distributors</option>
              <option v-if="isDistributor" :value="profileId">
                {{ loggedUserName }}
              </option>
              <option
                v-for="d in distributors"
                :key="d.profile_id"
                :value="d.profile_id"
              >
                {{ d.name }}
              </option>
            </select>
          </div>

          <div class="col-sm-6 col-md-3">
            <label class="form-label small text-muted mb-1">From Date</label>
            <input
              type="date"
              v-model="selectedFromDate"
              class="form-control form-control-sm"
              @change="fetchData"
            />
          </div>

          <div class="col-sm-6 col-md-3">
            <label class="form-label small text-muted mb-1">To Date</label>
            <input
              type="date"
              v-model="selectedToDate"
              class="form-control form-control-sm"
              @change="fetchData"
            />
          </div>

          <div class="col-sm-6 col-md-3 d-flex align-items-end">
            <button
              class="btn btn-sm btn-outline-secondary w-100"
              @click="exportExcel"
            >
              <i class="fa fa-download me-1"></i> Export CSV
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="d-flex justify-content-center py-5">
      <div class="spinner-border text-primary"></div>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-5 text-muted">{{ error }}</div>

    <!-- Table -->
    <!-- <div v-else-if="tableData.length" class="card"> -->
    <div
      v-else-if="tableData.length"
      class="card dispatch-detail-table-card mb-3"
    >
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <span class="fw-semibold">
          {{ selectedFromDate }} to {{ selectedToDate }} — Distributor &amp;
          Vehicle Breakdown
        </span>
        <span class="text-muted small">
          {{ totalVehicles }} vehicles across
          {{ tableData.length }} distributors
        </span>
      </div>

      <div class="card-body p-0">
        <!-- <div class="table-responsive">
          <table class="table table-bordered table-hover table-sm mb-0"> -->
        <div class="table-responsive dispatch-detail-table-scroll">
          <table
            class="table table-bordered table-hover table-sm mb-0 dispatch-detail-table"
          >
            <thead class="sticky-thead">
              <tr>
                <th style="min-width: 200px">Distributor</th>
                <th style="min-width: 130px">Vehicle No</th>
                <!-- <th class="text-end" style="min-width: 100px">Total Qty</th> -->
                <th class="text-end" style="min-width: 130px">Invoice Value</th>
                <template v-for="v in variants" :key="v.id">
                  <th class="text-end" style="min-width: 120px">
                    {{ v.name }}<br /><small class="text-muted">Qty</small>
                  </th>
                  <!-- <th class="text-end" style="min-width:140px">{{ v.name }}<br/><small class="text-muted">Value</small></th> -->
                </template>
              </tr>
            </thead>

            <tbody>
              <template v-for="dist in tableData" :key="dist.distributor_id">
                <tr
                  v-for="(vehicle, vIdx) in dist.vehicles"
                  :key="vehicle.vehicle_id"
                >
                  <td
                    v-if="vIdx === 0"
                    :rowspan="dist.vehicles.length"
                    class="align-middle dist-cell"
                  >
                    <div class="dist-name">{{ dist.distributor_name }}</div>
                    <div class="dist-totals">
                      <span class="dist-total-badge"
                        >Total Qty:
                        {{
                          distTotal(dist, "total_qty").toLocaleString()
                        }}</span
                      >
                      <span class="dist-total-badge"
                        >Value:
                        {{
                          formatCurrency(distTotal(dist, "invoice_value"))
                        }}</span
                      >
                    </div>
                  </td>

                  <td class="text-muted small align-middle">
                    {{ vehicle.vehicle_no }}
                  </td>

                  <!-- <td class="text-end align-middle fw-semibold">
                    {{
                      vehicle.total_qty > 0
                        ? vehicle.total_qty.toLocaleString()
                        : "-"
                    }}
                  </td> -->

                  <td class="text-end align-middle">
                    {{
                      vehicle.invoice_value > 0
                        ? formatCurrency(vehicle.invoice_value)
                        : "-"
                    }}
                  </td>

                  <template
                    v-for="variant in vehicle.variants"
                    :key="variant.variant_id"
                  >
                    <td
                      class="text-end align-middle"
                      :class="!variant.qty ? 'text-muted' : ''"
                    >
                      {{
                        variant.qty !== null
                          ? variant.qty.toLocaleString()
                          : "-"
                      }}
                    </td>
                    <!-- <td
                      class="text-end align-middle"
                      :class="!variant.value ? 'text-muted' : ''"
                    >
                      {{ variant.value !== null ? formatCurrency(variant.value) : '-' }}
                    </td> -->
                  </template>
                </tr>
              </template>
            </tbody>

            <tfoot class="sticky-tfoot">
              <tr class="table-dark fw-semibold">
                <td colspan="2" style="color: #fff">Grand Total</td>
                <!-- <td class="text-end" style="color: #fff">
                  {{ grandTotalQty().toLocaleString() }}
                </td> -->
                <td class="text-end" style="color: #fff">
                  {{ formatCurrency(grandTotalValue()) }}
                </td>
                <template v-for="v in variants" :key="v.id">
                  <td class="text-end" style="color: #fff">
                    {{ grandVariantTotal(v.id, "qty").toLocaleString() }}
                  </td>
                  <!-- <td class="text-end" style="color:#fff">{{ formatCurrency(grandVariantTotal(v.id, 'value')) }}</td> -->
                </template>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import {
  fetchDistributors,
  fetchLorryWiseSalesDetails,
} from "@/services/dataService";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default {
  name: "LorryWiseSalesDetail",

  data() {
    const q = this.$route?.query || {};
    return {
      MONTHS,
      token: localStorage.getItem("token_set"),
      profileId: localStorage.getItem("profile_id"),
      isDistributor: localStorage.getItem("user_label") === "DISTRIBUTOR",
      loggedUserName: localStorage.getItem("business_name"),

      loading: false,
      error: null,

      distributors: [],

      // Pre-fill from query params passed by the tile
      selectedDistributor: q.distributor || "",
      selectedFromDate: q.from_date || new Date().toISOString().split("T")[0],
      selectedToDate: q.to_date || new Date().toISOString().split("T")[0],

      categories: [],
      tableData: [],
      variants: [],
    };
  },

  mounted() {
    if (this.isDistributor) {
      this.selectedName = this.profileId;
    } else {
      this.loadDistributors();
    }

    this.fetchData();
  },

  computed: {
    yearOptions() {
      const years = [];
      for (let y = new Date().getFullYear(); y >= 2000; y--) years.push(y);
      return years;
    },

    totalVehicles() {
      return this.tableData.reduce((s, d) => s + d.vehicles.length, 0);
    },
  },

  methods: {
    async loadDistributors() {
      try {
        const res = await fetchDistributors(this.profileId, this.token);
        this.distributors = res.data.data;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchData() {
      try {
        this.loading = true;
        this.error = null;
        this.tableData = [];
        this.categories = [];

        const payload = {
          profile_id: this.selectedDistributor || this.profileId,
          distributor_id: this.selectedDistributor || "",
          from_date: this.selectedFromDate,
          to_date: this.selectedToDate,
        };

        const res = await fetchLorryWiseSalesDetails(payload, this.token);

        if (res.data.success && res.data.data.length > 0) {
          // this.categories = res.data.categories;
          this.variants = res.data.variants;
          this.tableData = res.data.data;
        } else {
          this.error = "No data available for the selected filters.";
        }
      } catch (e) {
        this.error = "Something went wrong. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    // Sum a field across all vehicles of a distributor
    distTotal(dist, field) {
      return dist.vehicles.reduce((s, v) => s + (v[field] || 0), 0);
    },

    grandTotalQty() {
      return this.tableData.reduce(
        (s, d) => s + this.distTotal(d, "total_qty"),
        0,
      );
    },

    grandTotalValue() {
      return this.tableData.reduce(
        (s, d) => s + this.distTotal(d, "invoice_value"),
        0,
      );
    },

    grandVariantTotal(variantId, field) {
      return this.tableData.reduce(
        (s, dist) =>
          s +
          dist.vehicles.reduce((vs, v) => {
            const variant = v.variants.find(
              (vr) => vr.variant_id === variantId,
            );
            return vs + (variant?.[field] || 0);
          }, 0),
        0,
      );
    },

    formatCurrency(val) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "LKR",
        maximumFractionDigits: 0,
      }).format(val || 0);
    },

    exportExcel() {
      // ── 1. Resolve filter display values ─────────────────────────────────────
      const distributorName =
        this.distributors.find((d) => d.profile_id === this.selectedDistributor)
          ?.name || "All Distributors";

      // ── 2. Filter / metadata rows ─────────────────────────────────────────────
      const filterRows = [
        ["Lorry Wise Sales Report"],
        [],
        ["Distributor", distributorName],
        ["From Date", this.selectedFromDate],
        ["To Date", this.selectedToDate],
        [],
      ];

      // ── 3. Column headers ─────────────────────────────────────────────────────
      //const variantHeaders = this.variants.flatMap(v => [`${v.name} Qty`, `${v.name} Value`]);
      const variantHeaders = this.variants.map((v) => `${v.name} Qty`);
      const headerRow = [
        "Distributor",
        "Vehicle No",
        // "Total Qty",
        "Invoice Value",
        ...variantHeaders,
      ];

      const totalCols = headerRow.length;
      const padTo = (arr) => {
        const out = Array.isArray(arr) ? [...arr] : [];
        while (out.length < totalCols) out.push("");
        return out.slice(0, totalCols);
      };

      // ── 4. Data rows + subtotals ──────────────────────────────────────────────
      const dataRows = [];

      this.tableData.forEach((dist) => {
        dist.vehicles.forEach((v, i) => {
          // const variantCols = this.variants.flatMap(variant => {
          //   const match = v.variants.find(vr => vr.variant_id === variant.id);
          //   return [match?.qty ?? 0, match?.value ?? 0];
          // });
          const variantCols = this.variants.map((variant) => {
            const match = v.variants.find((vr) => vr.variant_id === variant.id);
            return match?.qty ?? 0;
          });

          dataRows.push(
            padTo([
              i === 0 ? dist.distributor_name : "",
              v.vehicle_no,
              // v.total_qty || 0,
              v.invoice_value || 0,
              ...variantCols,
            ]),
          );
        });

        // Subtotal row per distributor
        // const distVariantCols = this.variants.flatMap((variant) => [
        //   this.grandVariantTotal(variant.id, "qty"), // reuse existing method
        //   this.grandVariantTotal(variant.id, "value"),
        // ]);

        // But for dist-level subtotals, sum only this dist's vehicles
        // const distVariantSubtotals = this.variants.flatMap((variant) => {
        //   const qty = dist.vehicles.reduce(
        //     (s, v) =>
        //       s +
        //       (v.variants.find((vr) => vr.variant_id === variant.id)?.qty || 0),
        //     0,
        //   );
        //   const value = dist.vehicles.reduce(
        //     (s, v) =>
        //       s +
        //       (v.variants.find((vr) => vr.variant_id === variant.id)?.value ||
        //         0),
        //     0,
        //   );
        //   return [qty, value];
        // });

        const distVariantSubtotals = this.variants.map((variant) => {
          return dist.vehicles.reduce((s, v) => {
            return (
              s +
              (v.variants.find((vr) => vr.variant_id === variant.id)?.qty || 0)
            );
          }, 0);
        });

        dataRows.push(
          padTo([
            `${dist.distributor_name} — Subtotal`,
            "",
            // this.distTotal(dist, "total_qty"),
            this.distTotal(dist, "invoice_value"),
            ...distVariantSubtotals,
          ]),
        );
      });

      // ── 5. Grand total row ────────────────────────────────────────────────────
      // const grandVariantCols = this.variants.flatMap((v) => [
      //   this.grandVariantTotal(v.id, "qty"),
      //   this.grandVariantTotal(v.id, "value"),
      // ]);
      const grandVariantCols = this.variants.map((v) =>
        this.grandVariantTotal(v.id, "qty"),
      );

      const grandTotalRow = padTo([
        "Grand Total",
        "",
        // this.grandTotalQty(),
        this.grandTotalValue(),
        ...grandVariantCols,
      ]);

      // ── 6. Footer ─────────────────────────────────────────────────────────────
      const firstName = localStorage.getItem("first_name") || "";
      const lastName = localStorage.getItem("last_name") || "";
      const userFullName = (firstName + " " + lastName).trim() || "-";
      const generatedAt = new Date().toLocaleString("en-US", { hour12: false });

      const footerRows = [
        [],
        ["Generated by", userFullName],
        ["Generated at", generatedAt],
      ];

      // ── 7. Assemble AOA ───────────────────────────────────────────────────────
      const aoa = [
        ...filterRows.map(padTo),
        padTo(headerRow),
        ...dataRows,
        grandTotalRow,
        ...footerRows.map(padTo),
      ];

      // ── 8. Build worksheet ────────────────────────────────────────────────────
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const headerRowIndex = filterRows.length;
      const grandTotalIndex = headerRowIndex + 1 + dataRows.length;

      // Title merge
      ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } }];

      // Column widths
      // ws["!cols"] = [
      //   { wch: 28 }, // Distributor
      //   { wch: 16 }, // Vehicle No
      //   { wch: 12 }, // Total Qty
      //   { wch: 16 }, // Invoice Value
      //   ...this.variants.flatMap(() => [{ wch: 14 }, { wch: 16 }]),
      // ];
      ws["!cols"] = [
        { wch: 28 }, // Distributor
        { wch: 16 }, // Vehicle No
        // { wch: 12 }, // Total Qty
        { wch: 16 }, // Invoice Value
        ...this.variants.map(() => ({ wch: 14 })),
      ];

      // Style: title bold + large
      const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
      if (ws[titleCell]) ws[titleCell].s = { font: { bold: true, sz: 14 } };

      // Style: header row bold
      headerRow.forEach((_, ci) => {
        const cell = XLSX.utils.encode_cell({ r: headerRowIndex, c: ci });
        if (ws[cell]) ws[cell].s = { font: { bold: true } };
      });

      // Style: subtotal rows bold
      aoa.forEach((row, ri) => {
        if (typeof row[0] === "string" && row[0].includes("— Subtotal")) {
          headerRow.forEach((_, ci) => {
            const cell = XLSX.utils.encode_cell({ r: ri, c: ci });
            if (ws[cell]) ws[cell].s = { font: { bold: true } };
          });
        }
      });

      // Style: grand total row bold
      headerRow.forEach((_, ci) => {
        const cell = XLSX.utils.encode_cell({ r: grandTotalIndex, c: ci });
        if (ws[cell]) ws[cell].s = { font: { bold: true } };
      });

      // ── 9. Write file ─────────────────────────────────────────────────────────
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Lorry Wise Sales");

      const fileName = `Dispatch_Summary_${this.selectedFromDate}_to_${this.selectedToDate}.xlsx`;
      XLSX.writeFile(wb, fileName);
    },
  },
};
</script>

<style scoped>
/* Sticky header fixed to PAGE scroll, not table scroll */
/* .sticky-thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  box-shadow: 0 2px 0 #dee2e6;
} */
.sticky-thead th {
  position: sticky;
  top: 0;
  z-index: 20;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #dbe3ef;
  box-shadow: 0 2px 0 rgba(15, 23, 42, 0.06);
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  vertical-align: middle;
}

/* Distributor cell */
.dist-cell {
  background-color: #f8f9fa;
  border-right: 2px solid #dee2e6;
  vertical-align: middle;
  padding: 10px 12px;
}

.dist-name {
  font-weight: 600;
  font-size: 13px;
  color: #2d3436;
  margin-bottom: 6px;
}

/* Inline total badges under distributor name */
.dist-totals {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.dist-total-badge {
  font-size: 10px;
  font-weight: 500;
  background: #e9ecef;
  color: #495057;
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
}

/* Premium inner table scroll */
.dispatch-detail-table-scroll {
  max-height: 470px;
  overflow: auto;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  border-radius: 0 0 12px 12px;
  background: #ffffff;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.78) #f1f5f9;

  /* subtle inner scroll hint */
  box-shadow: inset -10px 0 14px -14px rgba(15, 23, 42, 0.35),
    inset 0 -10px 14px -14px rgba(15, 23, 42, 0.35);
}

/* Chrome / Edge / Safari */
.dispatch-detail-table-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.dispatch-detail-table-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 999px;
}

.dispatch-detail-table-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
  border-radius: 999px;
  border: 2px solid #f1f5f9;
  min-height: 42px;
  min-width: 42px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);
}

.dispatch-detail-table-scroll::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #64748b 0%, #475569 100%);
  border-color: #e2e8f0;
}

.dispatch-detail-table-scroll::-webkit-scrollbar-thumb:active {
  background: linear-gradient(180deg, #475569 0%, #334155 100%);
}


/* Keeps horizontal scroll clean when many item columns exist */
.dispatch-detail-table {
  min-width: max-content;
}

.dispatch-detail-table th,
.dispatch-detail-table td {
  white-space: nowrap;
}

/* Nicer table body */
.dispatch-detail-table tbody tr {
  transition: background-color 0.18s ease;
}

.dispatch-detail-table tbody tr:hover {
  background-color: #f8fafc;
}

/* Sticky footer inside inner scroll */
.sticky-tfoot td {
  position: sticky;
  bottom: 0;
  z-index: 18;
  background: #111827 !important;
  border-color: #1f2937 !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
}

/* Card polish */
.card {
  border: 1px solid #e8edf4;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.045);
}

.card-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e8edf4;
}

/* Better mobile/tablet height */
@media (max-width: 768px) {
  .dispatch-detail-table-scroll {
    max-height: 70vh;
  }

  .dispatch-detail-table th,
  .dispatch-detail-table td {
    font-size: 12px;
  }
}

.dispatch-detail-page {
  padding-bottom: 14px !important;
}

.dispatch-detail-table-card {
  margin-bottom: 14px !important;
}

.dispatch-detail-table-card .card-body {
  padding-bottom: 0 !important;
}

.dispatch-detail-table-scroll {
  margin-bottom: 0 !important;
}

.dispatch-detail-table {
  margin-bottom: 0 !important;
}




.sticky-tfoot tr {
  border-bottom: 0 !important;
}

.sticky-tfoot td:first-child {
  border-bottom-left-radius: 0;
}

.sticky-tfoot td:last-child {
  border-bottom-right-radius: 0;
}

/* keep the scrollbar track premium but remove the white visual gap */

.dispatch-detail-table-scroll::-webkit-scrollbar-corner {
  background: #e2e8f0;
}


.dispatch-detail-table-scroll {
  background: #ffffff !important;
}

.dispatch-detail-table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  background: #ffffff;
}

.dispatch-detail-table th,
.dispatch-detail-table td {
  border-color: #e8edf4 !important;
}

/* Sticky footer should stay dark, but only inside cells */
.sticky-tfoot td {
  position: sticky;
  bottom: 0;
  z-index: 18;
  background: #111827 !important;
  border-color: #1f2937 !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
}

/* Keep scrollbar area light, not black */
.dispatch-detail-table-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 999px;
}

.dispatch-detail-table-scroll::-webkit-scrollbar-corner {
  background: #f1f5f9;
}
</style>
